// Action Types: Change language.
export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';

// Action Creators: Change language.
export const changeLanguage = (language) => {
  return { type: CHANGE_LANGUAGE, payload: language };
};
